import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, delay = 0, inView = false, className = "", lineClass = "" }) => {
  const trigger = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { animate: "show" };
  return (
    <motion.span className={`block ${className}`} initial="hidden" {...trigger}>
      {lines.map((line, i) => (
        <span key={i} className={`block overflow-hidden pb-[0.06em] ${lineClass}`}>
          <motion.span
            className="block"
            variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
            transition={{ duration: 1.25, ease: EASE, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const ClipImage = ({ src, alt, className = "", imgClass = "", delay = 0 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.1 }}
  >
    <motion.div
      className="relative h-full w-full overflow-hidden"
      variants={{ hidden: { clipPath: "inset(100% 0% 0% 0%)" }, show: { clipPath: "inset(0% 0% 0% 0%)" } }}
      transition={{ duration: 1.4, ease: EASE, delay }}
    >
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        className={`h-full w-full object-cover ${imgClass}`}
        variants={{ hidden: { scale: 1.25 }, show: { scale: 1 } }}
        transition={{ duration: 1.8, ease: EASE, delay }}
      />
    </motion.div>
  </motion.div>
);

export const Eyebrow = ({ index, children, className = "" }) => (
  <div className={`flex items-center gap-4 font-mono text-xs uppercase tracking-[0.25em] text-[#c8a97e] ${className}`}>
    {index && <span>{index}</span>}
    <span className="h-px w-10 bg-[#c8a97e]/60" />
    <span className="text-[#d6d3cd]">{children}</span>
  </div>
);
